const slick = require('slick-carousel'); //TODO Use Glide instead of slick https://glidejs.com/
const arrow = '<svg><use xlink:href="' + site.theme_uri + '/assets/icons/icons.svg#sprite-arrow"></use></svg>';

$('.tc-carousel').each(function () {
    const $this = $(this);
    if ($this.children().length > 1) {
        $this.slick({
            infinite: true
            , dots: true
            , nav: true
            , rows: 0
            , prevArrow: '<button type="button" class="slick-prev">' + arrow + '<span class="sr-only">Previous</span></button>'
            , nextArrow: '<button type="button" class="slick-next">' + arrow + '<span class="sr-only">Next</span></button>'
        });
    }
});

$('.featured-posts--slider').each(function () {
    const $this = $(this);
    const cols = parseInt($this.attr('data-columns'), 10) || 1;
    const medSize = (cols > 2) ? 2 : 1;
    if ($this.children().length > 1) {
        $this.slick({
            infinite: true
            , dots: true
            , nav: true
            , rows: 0
            , slidesToShow: 1
            , adaptiveHeight: true
            , prevArrow: '<button type="button" class="slick-prev">' + arrow + '<span class="sr-only">Previous</span></button>'
            , nextArrow: '<button type="button" class="slick-next">' + arrow + '<span class="sr-only">Next</span></button>'
            , mobileFirst: true
            , responsive: [
                {
                    breakpoint: 960
                    , settings: {
                        slidesToShow: medSize
                        , slidesToScroll: medSize
                    }
                }
                , {
                    breakpoint: 1200
                    , settings: {
                        slidesToShow: cols
                        , slidesToScroll: cols
                    }
                }
            ]
        });
    }
});
